import { useLingui } from "@lingui/react/macro";
import { companyApi } from "@/lib/api/services/company.api";
import type { Company } from "@/types/company";
import { EntitySelect } from "./EntitySelect";

export interface CompanySelectProps {
  value: number | null | undefined;
  onChange: (value: number, company: Company) => void;
  onClear?: () => void;
  organizationId?: number;
  isActive?: boolean;
  displayValue?: string;
  placeholder?: string;
  disabled?: boolean;
  triggerClassName?: string;
}

export function CompanySelect({
  value,
  onChange,
  onClear,
  organizationId,
  isActive,
  displayValue,
  placeholder,
  disabled,
  triggerClassName,
}: CompanySelectProps) {
  const { t } = useLingui();
  return (
    <EntitySelect<Company>
      queryKeyBase={["entity-select", "companies", organizationId ?? null, isActive ?? null]}
      fetchPage={({ page, limit, search }) =>
        companyApi.paginate({ page, limit, search: search || undefined, organizationId, isActive })
      }
      getOptionValue={(c) => String(c.id)}
      getOptionLabel={(c) => c.name}
      // No call site passes `displayValue`, so a concept id handed in as a
      // default (from a concept page, say) used to render as the bare number
      // "40". Resolve the name here rather than in six callers (T-204).
      fetchItem={(id) => companyApi.getById(Number(id))}
      value={value == null ? "" : String(value)}
      onChange={(val, company) => onChange(Number(val), company)}
      onClear={onClear}
      displayValue={displayValue}
      placeholder={placeholder ?? t`Select a concept...`}
      searchPlaceholder={t`Search concepts…`}
      emptyMessage={t`No concepts found`}
      disabled={disabled}
      triggerClassName={triggerClassName}
    />
  );
}
